import {
  FETCH_ATTENDANCE_HISTORY_SUCCESS,
  FETCH_ATTENDANCE_HISTORY_FAILURE,
} from './actions';
import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';
import AttendanceHistory from './model';

export default function attendanceHistory(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ATTENDANCE_HISTORY_SUCCESS:
      return ApiResponseHelper.create(AttendanceHistory.create(action.payload));
    case FETCH_ATTENDANCE_HISTORY_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/AttendanceHistory/reducer.js